// @flow

require('./js/transitions.js');

export { Step, StepOptions } from './js/step';
export type { StepsOptions } from './js/steps-base';

import { StepsMutuallyExclusive as StepsMutex } from './js/steps-mutex';
import { StepsMutuallyInclusive as StepsMutin } from './js/steps-mutin';
import { StepsMutuallyInclusiveGrouped as StepsGrouped } from './js/steps-grouped';

export const Steps = StepsMutex;
export { StepsMutex, StepsMutin, StepsGrouped };
